// extracted by mini-css-extract-plugin
export default {"field":"styles_field__SRdBw","link":"styles_link__tixow","checkbox":"styles_checkbox__vm45O","agreement":"styles_agreement__8vaCK","button":"styles_button__LFQtq"};